import { Badge } from "@/components/ui/badge";
import {
  BADGE_PRESENTATION,
  type MonitoringBadgeKind,
} from "./monitoring-constants";

export function MonitoringStatusBadge({
  kind,
  label,
  title,
}: {
  kind: MonitoringBadgeKind;
  label?: string;
  title?: string;
}) {
  const presentation = BADGE_PRESENTATION[kind];
  const Icon = presentation.icon;
  return (
    <Badge
      variant="outline"
      title={title}
      className={`gap-1 whitespace-nowrap ${presentation.className}`}
    >
      <Icon className="size-3.5 shrink-0" aria-hidden="true" />
      {label ?? presentation.label}
    </Badge>
  );
}
